import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ResourcesAllocationsInstancesApi(): BringozApi {
  return {
    base: `/resourceAllocations/instances`,
    infiniteScroll: {
      address: `/resourceAllocations/instances`,
      cmd: 'GET'
    },
    actions: {}
  }
}
angular
  .module('bringoz.admin.resources')
  .factory('resourcesAllocationsInstancesApi', ResourcesAllocationsInstancesApi);
